import coreAPI from 'apis/core';

export { upsertServiceTemplate, getOrganisationServiceTemplates } from './service-templates';

export const requestProActivation = (chainId, pharmacyId) => {
  return coreAPI.chain.requestProStatusActivation(chainId, pharmacyId);
};

export const requestProDetails = (chainId, pharmacyId) => {
  return coreAPI.chain.requestProDetails(chainId, pharmacyId);
};

export const getOrganisationInviteLink = async ({ chainId }) => {
  const data = await coreAPI.organisation.getOrganisationInviteLink({ chainId });
  return data.short_url;
};

export const registerWebsiteInterest = (chainId, pharmacyId) => {
  return coreAPI.chain.registerWebsiteInterest(chainId, pharmacyId);
};

export const getOrganisationDeliverySubscriptionPlans = (organisationId) => {
  return coreAPI.organisation.getOrganisationDeliverySubscriptionPlans(organisationId);
};

export const getOrganisationDeliveryExemptionPlans = (organisationId) => {
  return coreAPI.organisation.getOrganisationDeliveryExemptionPlans(organisationId);
};

export default {};
